<template>
  <div class="container">
    <div class="codeShowBackground">
      <div class="code_box">
        <div class="top">
          <div class="title">享受出厂价</div>
          <div class="privilege">特权码</div>
          <div class="timer">有效期：12个月</div>
        </div>
        <div class="bottom">
          <div class="surplus">特权码剩余：{{ CodeNum }} 张</div>
          <div class="codeButton">
            <img
              src="../../../../assets/images/codeButton.png"
              alt=""
              @click="goShopping"
            />
          </div>
          <div>注：下单时自动抵扣，单品限用1张</div>
        </div>
      </div>
      <!-- <button @click="goShopping">立即使用</button> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      CodeNum: 0
    };
  },
  mounted() {
    this.CodeNum = this.$route.query.CodeNum ? this.$route.query.CodeNum : 0;
  },

  methods: {
    goShopping() {
      this.$router.replace("page");
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  overflow: hidden;
}
.codeShowBackground {
  background-image: url(../../../../assets/images/codeBackground.png);
  height: 100vh;
  background-repeat: no-repeat;
  background-size: 100vw 100vh;
  position: relative;
}
.code_box {
  background-image: url(../../../../assets/images/code_box.png);
  height: 100%;
  background-repeat: no-repeat;
  background-size: 86vw 389.5px;
  margin: auto;
  width: 80vw;
  position: absolute;
  left: 50%;
  margin-left: -39vw;
  top: 50%;
  margin-top: -194px;
  .top {
    color: #ed0000;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 50vw;
    padding-top: 17vw;
    letter-spacing: 1px;
    .title {
      font-size: 9.6vw;
    }
    .privilege {
      font-size: 17vw;
    }
    .timer {
      font-size: 17px;
    }
  }

  .bottom {
    color: #fdf2e0;
    text-align: center;
    font-size: 12px;
    .surplus {
      padding-bottom: 2px;
    }
  }
}
.codeButton {
  width: 210px;
  height: 58px;
  margin: auto;
}
</style> 